<script>
export default {
  name: "Header",
  props: {
    patientName: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <header class="pr-0">
    <div class="d-flex justify--space-between">
      <img src="~@/assets/check-up-reports/evollu-default/evollu-logo.svg" alt="Evollu Logo">
      <div class="d-flex align-items-end flex-column" v-if="patientName && date">
        <span> {{ patientName }}</span>
        <span> {{ date }}</span>
      </div>
    </div>

    <hr>
  </header>
</template>

<style scoped lang="scss">
  header {
    padding: 10px 20px;
    width: 100%;
    height: 100px;
    margin-left: -20px !important;
    margin-top: -20px !important;
  }
</style>
